Vue.component('home-featured-streamers', {
    template: templates.homeFeaturedStreamers,
    data() {
        return {
            model: {
                featuredStreamers: [],
                isLoading: true
            }
        };
    },
    mounted() {
        this.loadFeatured();
    },
    methods: {
        loadFeatured() {
            const c = this;
            c.model.isLoading = true;

            featuredStreamerService.getFeatured()
                .then(function(response) {
                    c.model.featuredStreamers = response.data.featured || [];
                    c.model.isLoading = false;
                    c.checkLiveStatus();
                })
                .catch(function(error) {
                    console.error('Error loading featured streamers:', error);
                    c.model.isLoading = false;
                });
        },

        checkLiveStatus() {
            const c = this;
            if (c.model.featuredStreamers.length === 0) return;

            const twitchLogins = c.model.featuredStreamers.map(s => s.twitchLogin);

            axios.post('/api/streamer/check-live-status.php', { twitchLogins })
                .then(function(response) {
                    const liveStreamers = response.data.liveStreamers || [];

                    c.model.featuredStreamers.forEach(streamer => {
                        const liveData = liveStreamers.find(ls =>
                            ls.twitchLogin.toLowerCase() === streamer.twitchLogin.toLowerCase()
                        );

                        streamer.isLive = liveData ? liveData.isLive : false;
                        if (liveData) {
                            streamer.viewerCount = liveData.viewerCount;
                        }
                    });

                    c.$forceUpdate();
                })
                .catch(function(error) {
                    console.warn('Live status check failed:', error);
                });
        },

        openChannel(streamer) {
            window.open(`https://twitch.tv/${streamer.twitchLogin}`, '_blank');
        }
    }
});
